import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateTopic = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Forum Topic'
      fields={fields}
      apiPath='admin/topics'
      successRedirectPath={resource => `/write-now/topics/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateTopic
